import { render, staticRenderFns } from "./deleteTip.vue?vue&type=template&id=5c43d8dc"
import script from "./deleteTip.vue?vue&type=script&lang=js"
export * from "./deleteTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports